export default "__VITE_ASSET__ddd13775__"